export default "/images/vendor/flag-icon-css/flags/4x3/wf.svg?e9a373c6bcbf8ea5021ff0ce24b72e06";